import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule, Platform } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { NgLetModule } from 'ng-let';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { ListModule } from '../global/components/list.module';
import { PageLayoutModule } from '../global/page-layout';
import { LanguageModule } from '../global/language/language.module';
import { SharingModule } from '../global/sharing';
import { QRCodeModule } from '../global/qr-code-service';
import { ForceSyncService } from '../global';
import { DataSyncModule } from '../global/sync/sync.module';

import {
    AddUnitPage,
    ForcePage,
    ForceListPage,
    ForceTypePage,
    UnitPage,
    UnitOptionsPage,
    UnitDetailsPage,
    UnitDetailsComponent,
    ForceValidationComponent,
    PDFSettingsComponent,
    ShareForceComponent,
    UnitPoinstAdjustmentsComponent
} from './components';
import { ForceService } from './force.service';
import { FORCE_PIPES } from './pipes';
import { PDFService } from './components/pdf-settings/pdf-service';
import { sharedForcesReducer } from './shared-forces.reducer';
import { ImportForceComponent } from './components/import-force/import-force.component';
import { PlatoonSelectComponent } from './components/platoon-select/platoon-select.component';
import { getCombinedForceReducers } from './state/reducer';
import { ForceEffects } from './state/effects';
import { forceOrganisationReducer } from './organisation/state/reducer';
import { ForceOrganisationService } from './organisation/force-organisation.service';
import { ForceCustomListComponent } from './organisation/components/force-custom-list.component';
import { ForceFolderItemComponent } from './organisation/components/force-folder-item.component';

let forcesLoaded = false;

export const FORCE_STANDALONE_COMPONENTS = [PDFSettingsComponent];

export const FORCE_COMPONENTS = [
    AddUnitPage,
    ForceListPage,
    ForcePage,
    ForceTypePage,
    UnitPage,
    UnitOptionsPage,
    UnitDetailsPage,
    UnitDetailsComponent,
    ForceValidationComponent,
    ShareForceComponent,
    ImportForceComponent,
    PlatoonSelectComponent,
    UnitPoinstAdjustmentsComponent,
    ForceCustomListComponent,
    ForceFolderItemComponent
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild([]),
        IonicModule,
        ListModule,
        PageLayoutModule,
        TranslateModule,
        NgLetModule,
        LanguageModule,
        FormsModule,
        EffectsModule.forFeature([ForceEffects]),
        StoreModule.forFeature('forces', getCombinedForceReducers()),
        StoreModule.forFeature('sharedForces', sharedForcesReducer),
        StoreModule.forFeature('forceOrganisation', forceOrganisationReducer),
        SharingModule,
        QRCodeModule,
        ReactiveFormsModule,
        DataSyncModule,
        ...FORCE_PIPES,
        ...FORCE_STANDALONE_COMPONENTS
    ],
    declarations: [...FORCE_COMPONENTS],
    exports: [...FORCE_COMPONENTS, ...FORCE_PIPES, ...FORCE_STANDALONE_COMPONENTS],
    providers: [PDFService, ForceOrganisationService]
})
export class ArmyBuilderForceModule {
    constructor(
        forceService: ForceService,
        platform: Platform,
        private syncService: ForceSyncService
    ) {
        // entityDataService.registerService('Force', forceDataService);

        platform.ready().then(async () => {
            if (!forcesLoaded) {
                // Hacky way to ensure forces only get loaded once
                // since this module is being lazy loaded, and thus
                // isn't a singleton
                forcesLoaded = true;
                await forceService.loadFromStorage();
            }
        });
    }
}
